/* unplugin-vue-components disabled */import script from "./commonArea.vue?vue&type=script&setup=true&lang=js"
export * from "./commonArea.vue?vue&type=script&setup=true&lang=js"

import "./commonArea.vue?vue&type=style&index=0&id=20283578&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20283578"]])

export default __exports__